import * as React from 'react';
import {
    List,
    DataTable,
    TextField,
    Pagination,
    SelectInput,
    TextInput,
    TopToolbar,
    ExportButton,
    ColumnsButton,
    useDefaultTitle,
    useListContext,
    FilterButton,
    useDataProvider,
    useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { useEffect, useState } from 'react';

// filters will be built inside the component to allow async choices

const ChatListActions = () => (
    <TopToolbar>
        <FilterButton />
        <ColumnsButton />
        <ExportButton />
    </TopToolbar>
);

const ChatTitle = () => {
    const title = useDefaultTitle();
    const { defaultTitle } = useListContext();
    return (
        <>
            <title>{`${title} - ${defaultTitle}`}</title>
            <span>{defaultTitle}</span>
        </>
    );
};

type Chat = {
    pid: number;
    aid: number;
    role: string;
    type: string;
    content: string;
};

const Column = DataTable.Col<Chat>;

const PlayerField = ({ choices }: { choices: Array<any> }) => {
    const record = useRecordContext<Chat>();
    if (!record) return null;
    const item = choices.find((p: any) => p.id === record.pid || p.id == record.pid);
    return <span>{item ? item.name : record.pid}</span>;
};

const AiField = ({ choices }: { choices: Array<any> }) => {
    const record = useRecordContext<Chat>();
    if (!record) return null;
    const item = choices.find((a: any) => a.id === record.aid || a.id == record.aid);
    return <span>{item ? item.name : record.aid}</span>;
};

const RoleField = () => {
    const record = useRecordContext<Chat>();
    if (!record) return null;
    return <Chip label={record.role} color="primary" size="small" />;
};

const ChatList = () => {
    const dataProvider = useDataProvider();
    const [playerChoices, setPlayerChoices] = useState<Array<any>>([]);
    const [aiChoices, setAiChoices] = useState<Array<any>>([]);

    useEffect(() => {
        let mounted = true;
        dataProvider
            .getList('admin/dropdown/players', { pagination: { page: 1, perPage: 1000 }, sort: { field: '', order: 'ASC' }, filter: {} })
            .then(({ data }) => {
                if (mounted) setPlayerChoices(data || []);
            })
            .catch(() => {});
        dataProvider
            .getList('admin/dropdown/ai', { pagination: { page: 1, perPage: 1000 }, sort: { field: '', order: 'ASC' }, filter: {} })
            .then(({ data }) => {
                if (mounted) setAiChoices(data || []);
            })
            .catch(() => {});
        return () => {
            mounted = false;
        };
    }, [dataProvider]);

    const filters = [
        <SelectInput key="playerId" label="Player" source="playerId" choices={playerChoices}/>,
        <SelectInput key="aiId" label="AI" source="aiId" choices={aiChoices}/>,       
    ];

    return (
        <List filters={filters} pagination={<Pagination />} actions={<ChatListActions />} title={<ChatTitle />}>
            <DataTable rowClick="edit" bulkActionButtons={false}>
                <Column source="pid" label="Player">
                    <PlayerField choices={playerChoices} />
                </Column>
                <Column source="aid" label="AI">
                    <AiField choices={aiChoices} />
                </Column>
                <Column source="role" label="Role">
                    <RoleField />
                </Column>
                <Column source="type" label="Type">
                    <TextField source="type" />
                </Column>
                <Column source="content" label="Content">
                    <TextField source="content" />
                </Column>
            </DataTable>
        </List>
    );
};

export default ChatList;